import { DateTime } from 'luxon'

export const useProp = (type, defaults = null, required = false, validator = null) => {
  return {
    type,
    default: defaults === null ? createDefaults(type, defaults) : defaults,
    required,
    validator
  }
}

const createDefaults = (type, defaults) => {
  if (Array.isArray(type) && defaults === null) {
    return null
  }

  switch (type) {
    case Boolean: return false
    case Object: return () => { return {} }
    case Function: return () => { console.log('test') }
    case Array: return () => { return [] }
    case Date: return DateTime.now()
    case Number: return 0
    default: return ''
  }
}
